import React from "react";
import { Link } from "react-router-dom";
import "react-multi-carousel/lib/styles.css";

const Project = () => {
	return (
		<div className="my-project py-5">
			<div className="container-fluid px-0 z-10">
				<div className="container">
					<div className="row pt-md-5 z-10">
						<div className="col-md-10 d-lg-flex justify-lg-center mx-md-auto mt-5 mt-md-0">
							<div className="col-lg-8">
								<h1 className="display-5 font-weight-bold">My Projects</h1>
								<p>
									Over the past few years I’ve had the chance to work on multiple projects with a human centered approach
									and empathy driven mindset. Projects range from a simple redesign to a complete user experience revamp.
								</p>
							</div>

							<div className="col-lg-4 pt-4 pb-5 pb-md-0">
								<div className="d-flex justify-center items-center">
									<Link
										to="#"
										target="_blank"
										className="btn btn-outline-white d-flex justify-content-between px-md-4 py-3 br-0 w-100"
									>
										All Case Studies
										<span>
											<svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path
													d="M5.62405 1.7645L1.51182 5.87674L0.836243 5.20116L4.948 1.08893H1.32405V0.133369H6.57961V5.38893H5.62405V1.7645Z"
													fill="white"
												/>
											</svg>
										</span>
									</Link>
								</div>
							</div>
						</div>

						<div className="col-md-12 d-flex flex-wrap flex-column flex-md-row justify-center items-center justify-md-between z-10">
							<div className="col-md-6 d-flex justify-content-center align-items-center mx-6 my-4">
								<a
									href="https://medium.com/@fabusuyioluwatobi/exploring-payments-for-africa-4b9e5d814520"
									target="_blank"
									rel="noreferrer"
									className="d-block"
								>
									<div className="position-relative">
										<img className="project-img" src="/assets/project1.png" alt="Boundless pay" />
									</div>
								</a>
							</div>
							<div className="col-md-6 d-flex justify-content-center align-items-center mx-6 my-4">
								<a
									href=" https://medium.com/@fabusuyioluwatobi/qxr-416cf37f8b50"
									target="_blank"
									rel="noreferrer"
									className="d-block"
								>
									<div className="position-relative">
										<img className="project-img" src="/assets/project2.png" alt="QXB" />
									</div>
								</a>
							</div>
							<div className="col-md-6 d-flex justify-content-center align-items-center mx-6 my-4">
								<a
									href="https://medium.com/@fabusuyioluwatobi/sogovr-immersive-entertainment-from-your-comfort-dd9b993ec73c"
									target="_blank"
									rel="noreferrer"
									className="d-block"
								>
									<div className="position-relative">
										<img className="project-img" src="/assets/project3.png" alt="SogoVR" />
									</div>
								</a>
							</div>
							<div className="col-md-6 d-flex justify-content-center align-items-center mx-6 my-4">
								<a
									href="https://medium.com/@fabusuyioluwatobi/redefining-fitness-experience-in-pandemics-108147180fb"
									target="_blank"
									rel="noreferrer"
									className="d-block"
								>
									<div className="position-relative">
										<img className="project-img" src="/assets/project4.png" alt="Boundless pay" />
									</div>
								</a>
							</div>
						</div>
					</div>

					<div className="about ffm">
						<div className="container h-100 d-flex justify-content-start align-items-center px-0">
							<h1 className="font-weight-bold">
								My
								<br />
								\Projects.
							</h1>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Project;
